import { useEffect, useRef } from "react";
import "./Confirmation.css";

export const ModalDialog = ({ modal, children, title, styles }) => {
    const dialogRef = useRef(null);

    const handleModal = (e) => {
        if (e.key === "Escape") {
            modal.remove();
        }
    };

    //NOTE: Ref in use here to invoke showDialog, which will allow the triggering
    //of the pseudo-element ::backdrop for the <dialog> element.
    useEffect(() => {
        let refCopy = null;

        dialogRef.current.addEventListener("keydown", handleModal);
        dialogRef.current.showModal();
        refCopy = dialogRef.current;

        return () => {
            if (refCopy) {
                console.log("unload dialog");
                refCopy.removeEventListener("keydown", handleModal);
            }
        };
    }, []);

    return (
        <dialog style={{ ...styles }} ref={dialogRef}>
            <header>
                <div className="dialog-title">{title}</div>
                <div
                    className="close-button"
                    onClick={() => {
                        modal.remove();
                    }}
                >
                    X
                </div>
            </header>
            <main>{children}</main>
        </dialog>
    );
};
